
















































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PageSelect from './pcDecorateSelect.vue'
import MallConfig from '@/api/mall/mallConfig/index'
import GoodsSelect from '@/components/goods-select/index.vue'
import ActivitySelect from '@/components/activity-select/index.vue'
import OutfitSelect from '@/components/outfit-select/index.vue'
import RewardPointGameSelect from '@/components/rewardPointGameSelect/index.vue'
import ArticleSelect from '@/components/article-select/index.vue'
import RewardPointProductSelect from '@/components/reward-point-product-select/index.vue'
import CouponActivitySelect from '@/components/couponActivity-select/index.vue'
import GoodListConfig from '@/components/good-list-config/index.vue'
import CustomCategorySelect from '@/components/custom-category-select/index.vue'
@Component({
  components: {
    GoodsSelect,
    ActivitySelect,
    OutfitSelect,
    RewardPointGameSelect,
    ArticleSelect,
    RewardPointProductSelect,
    PageSelect,
    CouponActivitySelect,
    GoodListConfig,
    CustomCategorySelect,
  },
})
export default class SelectUrl extends Vue {
  @Prop({
    type: String,
    default: () => {
      return null
    },
  })
  selectUrl!: string

  showUrl = null
  MallUrlListConfig = []

  showGoods = false
  showActivity = false
  showOutfit = false
  showArticle = false
  showRewardPointGame = false
  showRewardPointProduct = false
  showDiyPage = false
  showCoupon = false
  showGoodListConfig = false
  showCustomCategoryConfig = false
  // 0 大转盘 1 刮刮乐
  rewardPointGameType = 0
  /**
   * limitDiscount 限时折扣
   * preSales 预售
   * group 拼团
   * secKill 秒杀
   * buyGetOne 满X件免一
   * tierDiscount 满减满折
   * freeShipping 满包邮
   */
  activityType = 'group'

  // limitBuyCoupon 限时购券 helpGetCoupon 助力领券
  couponType = 'helpGetCoupon'

  async created() {
    this.getConfig()
  }

  @Watch('selectUrl', {
    immediate: true,
  })
  selectUrlChange(value) {
    // console.log('选择地址', value);
    let text = value
    if (value) {
      if (
        value.indexOf('/activity/activityCommon') > -1 ||
        value.indexOf('/goods/list') > -1 ||
        value.indexOf('/activity/packactivity') > -1 ||
        value.indexOf('/activity/preSale') > -1 ||
        value.indexOf('/activity/spike') > -1
      ) {
        text = value.split('&')[0]
      } else if (value.indexOf('/goods/detail/') > -1) {
        text = value.slice(0, value.lastIndexOf('/') + 1)
      } else {
        text = value.split('?')[0]
      }
    }
    this.showUrl = text
  }

  /**
   * 获取设置
   */
  getConfig() {
    MallConfig.getMallConfig('PcMallUrlListConfig').then((res) => {
      console.log(res)
      if (res.data.UrlItems) {
        this.MallUrlListConfig = res.data.UrlItems
      }
    })
  }

  urlChange(e) {
    console.log(e)
    console.log('urlChange')
    this.MallUrlListConfig.some((item) => {
      if (item.Value == e) {
        // type 0 基础路径不需要加参数 1 商品详情 2 拼团列表 3 预售列表 4 秒杀列表 5 满X件免一列表 6 满减满折列表
        // 7 满包邮列表 8 限时折扣列表 9 大转盘 10 刮刮乐 11 积分商品详情 12 文章详情 13 微页面 14 助力领券 15 限时购券 16商品列表 17商品分组
        // 18 商品打包 19 套装活动 20 满送活动
        switch (item.type) {
          case 0:
            this.ok(this.showUrl)
            break
          case 1:
            this.showGoods = !this.showGoods
            break
          case 2:
            this.activityType = 'group'
            this.showActivity = !this.showActivity
            break
          case 3:
            this.activityType = 'preSales'
            this.showActivity = !this.showActivity
            break
          case 4:
            this.activityType = 'secKill'
            this.showActivity = !this.showActivity
            break
          case 5:
            this.activityType = 'buyGetOne'
            this.showActivity = !this.showActivity
            break
          case 6:
            this.activityType = 'tierDiscount'
            this.showActivity = !this.showActivity
            break
          case 7:
            this.activityType = 'freeShipping'
            this.showActivity = !this.showActivity
            break
          case 8:
            this.activityType = 'limitDiscount'
            this.showActivity = !this.showActivity
            break
          case 9:
            this.rewardPointGameType = 0
            this.showRewardPointGame = !this.showRewardPointGame
            break
          case 10:
            this.rewardPointGameType = 1
            this.showRewardPointGame = !this.showRewardPointGame
            break
          case 11:
            this.showRewardPointProduct = !this.showRewardPointProduct
            break
          case 12:
            this.showArticle = !this.showArticle
            break
          case 13:
            this.showDiyPage = !this.showDiyPage
            break
          case 14:
            this.couponType = 'helpGetCoupon'
            this.showCoupon = !this.showCoupon
            break
          case 15:
            this.couponType = 'limitBuyCoupon'
            this.showCoupon = !this.showCoupon
            break
          case 16:
            this.showGoodListConfig = !this.showGoodListConfig
            break
          case 17:
            this.showCustomCategoryConfig = !this.showCustomCategoryConfig
            break
          case 18:
            this.activityType = 'productPack'
            this.showActivity = !this.showActivity
            break
          case 19:
            this.activityType = 'outfit'
            this.showActivity = !this.showActivity
            break
          case 20:
            this.activityType = 'buyGetGiveaway'
            this.showActivity = !this.showActivity
            break
          case 21:
            this.couponType = 'grabCoupon'
            this.showCoupon = !this.showCoupon
            break
          case 22:
            this.activityType = 'outfit'
            this.showOutfit = !this.showOutfit
            break
          default:
            break
        }
        return true
      }
    })
  }

  /**
   * 选择商品详情/积分商品详情
   */
  selectGoods(e) {
    if (e && this.showUrl) {
      let url = this.showUrl + e
      this.ok(url)
    } else {
      this.cancel()
    }
  }

  /**
   * 选择活动
   */
  selectActivity(e:any,promotionId:string,title:string) {
    console.log(e)
    if (
      e &&
      this.showUrl &&
      (this.showUrl.indexOf('/activity/activityCommon') > -1 ||
        this.showUrl.indexOf('/activity/packactivity') > -1 ||
        this.showUrl.indexOf('/activity/preSale') > -1 ||
        this.showUrl.indexOf('/activity/spike') > -1 ||
        this.showUrl.indexOf('/activity/outfitdel') > -1)
    ) {
      let url = ''
      if(this.showUrl.indexOf('/activity/outfitdel') > -1){
        url = `${this.showUrl}?outfitId=${e.promotionOutfitId}&id=${promotionId}&title=${title}`
      }else{
        url = `${this.showUrl}&title=${e.name}&id=${e.id}`
      }
      this.ok(url)
    } else {
      this.cancel()
    }
  }

  /**
   * 通用选择
   */
  selectChange(e) {
    if (e && this.showUrl) {
      let url = this.showUrl + '?id=' + e.id
      this.ok(url)
    } else {
      this.cancel()
    }
  }

  ok(e) {
    this.$emit('on-change', e)
  }

  cancel() {
    this.ok(null)
    let selectUrl: any = this.$refs.selectUrl
    selectUrl.clearSingleSelect()
  }

  setGoodListConfig(obj) {
    const temp = {}
    for (const name in obj) {
      if (obj.hasOwnProperty(name) && obj[name]) {
        temp[name] = obj[name]
      }
    }
    let url = `${this.showUrl}`
    if (Object.keys(temp).length !== 0) {
      url += '&' + this.serialize(temp).slice(1)
    }
    this.ok(url)
  }

  // obj to query string
  serialize(obj) {
    let str =
      '?' +
      Object.keys(obj)
        .reduce(function (a, k) {
          a.push(k + '=' + encodeURIComponent(obj[k]))
          return a
        }, [])
        .join('&')
    return str
  }

  goodListOnOk(obj) {
    this.setGoodListConfig(obj)
  }
  goodListOnCancel(obj) {
    this.setGoodListConfig(obj)
  }
  customCategoryOnOk(obj) {
    var url = this.showUrl
    this.ok(`${url}&custom=${obj.CategoryId}`)
  }
  customCategoryOnCancel(obj) {
    this.ok('')
  }
}
